import { HubConnectionBuilder } from "@microsoft/signalr";
import React, { createContext, useContext, useEffect, useState } from "react";

type HubCheckInContextType = {
    children: React.ReactNode
}

type HubCheckinStoreType = {
    _connectionServer: any;
    _isConnected: boolean
}

const HubCheckinContext = createContext({} as HubCheckinStoreType);
const useHubCheckinContext = () => useContext(HubCheckinContext);
const reConnectTime: number = 5000;
const HubCheckinProvider = ({ children }: HubCheckInContextType) => {
    const [connectionServer, setConnectionServer] = useState<any>(null);
    const [isConnected, setIsConnected] = useState<boolean>(false);
    console.log({
        isConnected
    });

    const store: HubCheckinStoreType = {
        _connectionServer: connectionServer,
        _isConnected: isConnected
    }
    useEffect(() => {

        const connection = new HubConnectionBuilder()
            // .withUrl("https://edi-parentapp-dev.1school.edu.vn/hubs/face-id-cham-an?userId=1")
            .withUrl("https://parent-app.edisonschools.edu.vn/hubs/face-id-cham-an?userId=1")
            .withAutomaticReconnect()
            .build();

        setConnectionServer(connection);
    }, []);


    useEffect(() => {
        if (connectionServer) {

            connectionServer.start()
                .then((result: any) => {
                    setIsConnected(true);
                    console.log('ConnectionServer Connected!');
                })
                .catch((e: any) => {
                    console.log('connectionServer failed: ', e)
                    const intervalId = setInterval(() => {
                        console.log('Try reconnect connectionServer');
                        if (connectionServer) {
                            try {
                                connectionServer.start()
                                    .done(function () {
                                        setIsConnected(true);
                                        clearInterval(intervalId);
                                    })
                            } catch (error) {

                            }
                        }


                    }, reConnectTime);
                });
            // sự kiện khi bị disconnect
            connectionServer.onclose((error: any) => {
                console.error("Connection closed due to error: ", error);
                setIsConnected(false);
            });

            // sự kiện khi reconnect
            connectionServer.onreconnecting((error: any) => {
                console.warn("Reconnecting... ", error);
                setIsConnected(false);
            });

            // sự kiện khi đã reconnect thành công
            connectionServer.onreconnected((connectionId: any) => {
                console.log("Reconnected. Connection ID: ", connectionId);
                setIsConnected(true);
            });
        }
        return (() => {
            if (connectionServer) {
                connectionServer.stop();
                setIsConnected(false)
            }
        })
    }, [connectionServer]);

    return (
        <HubCheckinContext.Provider value={store}>
            {children}
        </HubCheckinContext.Provider>
    );
}
export {
    HubCheckinProvider,
    useHubCheckinContext
};

